import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { remote } from "ccui-framework";
import { useDispatch, useSelector } from "react-redux";
import { OrderCardsList, doCartReset } from "../../Card";
import styled from "@emotion/styled";
import { OrderInfo } from "./OrderInfo";
import { EcodeReceipt } from "./EcodeReceipt";
import { PhysicalReceipt } from "./PhysicalReceipt";
import { configSelector } from "ccui-framework";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Receipt = ({ orderId = null }) => {
  const dispatch = useDispatch();
  const [cards, setCards] = useState([]);
  const [order, setOrder] = useState({});
  const [running, setRunning] = useState(true);
  const { supportEmail, supportPhone, brand } = useSelector((state) =>
    configSelector(state)
  );

  const fetch = async () => {
    try {
      const [order, cards] = await Promise.all([
        remote("get", `v3/orders/${orderId}`, "", `get ${orderId}`, dispatch),
        remote(
          "get",
          `v3/cards/sell?orderId=${orderId}`,
          "",
          `get ${orderId} cards`,
          dispatch
        ),
      ]);

      if ("message" in order || !"sellOrder" in order) {
        throw new Error("no order found!");
      }
      if ("message" in cards || !"sellCards" in cards) {
        throw new Error("order has no cards!");
      }

      setCards(cards.sellCards);
      setOrder(order.sellOrder);
      setRunning(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (orderId) {
      fetch();
    }

    return () => {
      setCards([]);
      setOrder({});
      setRunning(true);
      dispatch(doCartReset());
    };
  }, []);

  if (running) {
    return "loading...";
  }

  if (!running && Object.keys(order) && Object.keys(cards)) {
    const {
      customerDetails,
      orderId,
      requestedPaymentMethod,
      status,
      type,
      date: { placed = null },
      cardsValue,
      barcode,
    } = order;

    const totalFaceValue = cards.reduce((acc, card) => {
      return acc + Number(card.enteredValue);
    }, 0.0);

    return (
      <Container>
        <OrderInfo
          customerDetails={customerDetails}
          orderId={orderId}
          requestedPaymentMethod={requestedPaymentMethod}
          status={status}
          type={type}
          datePlaced={placed}
          numCards={cards?.length}
          cardsValue={cardsValue}
          totalFaceValue={totalFaceValue}
          print={() => {
            window.print();
          }}
        />
        <OrderCardsList cards={cards} />
        {type === "ecode" ? (
          <EcodeReceipt
            supportEmail={supportEmail}
            supportPhone={supportPhone}
            brand={brand}
          />
        ) : (
          <PhysicalReceipt brand={brand} barcode={barcode} />
        )}
      </Container>
    );
  }

  return null;
};

Receipt.prototype = {
  orderId: PropTypes.string.isRequired,
};

export { Receipt };
